if (typeof waitForSwiper === 'undefined') {
    const waitForSwiper = (callback) => {
        if (typeof Swiper !== 'undefined') {
            callback();
        } else {
            setTimeout(() => waitForSwiper(callback), 100);
        }
    };
}


productDetailsWrapper = document.querySelector(".product_details_page_section");
const productGalleryWrapper = document.querySelector(".PS-001-product-gallery-wrapper");

const productInfoWrapper = document.querySelector(".product__info-wrapper");
productInfoWrapper.classList.add("PS-001-product-info-wrapper");

const productGalleryThumbnailCont = productGalleryWrapper.querySelectorAll(".slider-mobile-gutter")[1];
if (productGalleryThumbnailCont != null) {
    productGalleryThumbnailCont.classList.add("PS-001-product-gallery-thumbnail-cont")

    const galleryThumbnailDown = document.createElement("button");
    galleryThumbnailDown.classList.add("PS-001-gallery-thumbnail-down");
    galleryThumbnailDown.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
            <path d="M5.23853 6.46851L9.55112 10.7811L13.8637 6.46851" stroke="white" stroke-width="1.07815" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;
    productGalleryThumbnailCont.append(galleryThumbnailDown);
}

document.addEventListener("mouseup", (e) => {
    if (e.target.classList.contains("PS-001-gallery-thumbnail-up")) {
        productGalleryThumbnailCont.querySelector("ul").scrollTop -= 200;
    } else if (e.target.classList.contains("PS-001-gallery-thumbnail-down")) {
        productGalleryThumbnailCont.querySelector("ul").scrollTop += 200;
    }
});

const productInfo = productInfoWrapper.children[0];
productInfo.classList.add("PS-001-product-info")

const productTitle = productInfo.querySelector("h1");
const productRating = productInfo.querySelector(".jdgm-prev-badge");
/* const madeInBadge = document.createElement("img");
madeInBadge.src = "https://cdn.shopify.com/s/files/1/0800/1008/4636/files/ps-pdp-made-in.png?v=1728618264";
madeInBadge.classList.add("PS-001-made-in-badge");
productTitle.after(madeInBadge);
*/
document.querySelector(".qty-corrections").classList.remove("qty-corrections")
setTimeout(() => {
    const qtySelectorInput = document.querySelector(".price-per-item__container");
    const atcCont = document.querySelector(".product-form__buttons");
    atcCont.prepend(qtySelectorInput);
    document.querySelector(".product-form__input.product-form__quantity").style.display = `none`;
}, 300)

const collapsables = document.querySelectorAll(".product__accordion.accordion.quick-add-hidden");
collapsables[0].classList.add("collapsable__disabled")

/* Swiper */
if (document.querySelector(".brands-carousel")) {
    waitForSwiper(() => {
        var brandsSwiper = new Swiper(".brandsCarousel", {
            breakpoints: {
                0: { slidesPerView: "4.25" },
                500: { slidesPerView: "5.25" },
                600: { slidesPerView: "6" },
                720: { slidesPerView: "7" },
                750: { slidesPerView: "3.25" }
            },
            spaceBetween: 0,
            loop: true,
            autoplay: { delay: 0 },
            speed: 4500,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    });

    if (productGalleryThumbnailCont === undefined) {
        const galleryCont = document.createElement("div");
        galleryCont.style.position = `sticky`
        document.querySelector("media-gallery").style.position = `static`
        document.querySelector(".grid__item.product__media-wrapper").prepend(galleryCont)
        galleryCont.append(document.querySelector("media-gallery"));
        galleryCont.append(document.querySelector(".brands-carousel"));
        document.querySelector(".brands-carousel").style.position = `sticky`
    }
}

const faqTitle = document.querySelector(".collapsible-content__heading.inline-richtext.h1");
faqTitle.innerHTML = `We're a small shop with <br> real people, and we're here to help.`;

const faqCont = document.querySelector(".collapsible-content");
faqCont.classList.add("PS-001-faq-cont");

const observeProductRecommendations = () => {
    const observer = new MutationObserver((mutations, obs) => {
        const productRecommendations = document.querySelector("product-recommendations");
        if (productRecommendations && productRecommendations.querySelectorAll("li").length > 0) {
            obs.disconnect();

            const recommendedProducts = productRecommendations.querySelectorAll("li");

            const recommendedProductsSwiper = document.createElement("div");
            recommendedProductsSwiper.classList.add("recommendedSwiper");
            recommendedProductsSwiper.innerHTML = `
                <h2 class="recommended-products-title">Shop Similar Items</h2>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-pagination"></div>
                <div class="swiper-wrapper">
                    ${Array.from(recommendedProducts).map(product => {
                        const url = product.querySelector("a").href;
                        return `
                            <div class="swiper-slide">
                                ${product.innerHTML}
                                <a class="product-cta" href="${url}" rel="noopener">View Product</a>
                            </div>
                        `;
                    }).join('')}
                </div>
            `;

            productRecommendations.parentElement.prepend(recommendedProductsSwiper);
            productRecommendations.remove();

            waitForSwiper(() => {
                new Swiper(".recommendedSwiper", {
                    breakpoints: {
                        0: { slidesPerView: "1.15" },
                        450: { slidesPerView: "1.5" },
                        750: { slidesPerView: "2.8" },
                        1250: { slidesPerView: "4" }
                    },
                    spaceBetween: 20,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    },
                    loop: true
                });
            });
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
};

observeProductRecommendations();

const variantPickerTitles = document.querySelectorAll(".variant-picker__title");
Array.from(variantPickerTitles).forEach((title) => {
    if (title.textContent.toLowerCase() === "shaving creams" || title.textContent.toLowerCase() === "shaving products") {
        title.textContent = "Select Size";
    } else {
        title.textContent = "Select Quantity";
    }
});

const waitForElement2 = (element, callback) => {
    const maxWaitTime = 7000;
    const interval = 90;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
        const selector = document.querySelector(element);
        if (selector) {
            callback();
            clearInterval(waitingInterval);
        } else {
            elapsedTime += interval;
            if (elapsedTime >= maxWaitTime) {
                clearInterval(waitingInterval);
            }
        }
    }, interval);
};

waitForElement2(".yotpo-subscription-benefits-list", () => {
    const subscriptionBenefitsList = document.querySelector(".yotpo-subscription-benefits-list");

    if (subscriptionBenefitsList) {
        subscriptionBenefitsList.style.display = "flex";
        subscriptionBenefitsList.style.alignItems = "center";
        subscriptionBenefitsList.style.justifyContent = "center";
        subscriptionBenefitsList.style.flexWrap = "wrap";
        subscriptionBenefitsList.style.gap = "0 2rem";
        subscriptionBenefitsList.innerHTML = `
            <li class="yotpo-subscription-benefits-list-bullet" style="font-weight: 400 !important;"> Free Shipping </li>
            <li class="yotpo-subscription-benefits-list-bullet" style="font-weight: 400 !important;"> Advance Reminder </li>
            <li class="yotpo-subscription-benefits-list-bullet" style="font-weight: 400 !important;"> Change or cancel anytime </li>
        `;
    }

    const subscriptionTitle = document.createElement("h3");
    subscriptionTitle.classList.add("plan-selector-title");
    subscriptionTitle.innerHTML = `Subscribe & Save (10%)`;

    if (!document.querySelector(".subscription-title")) {
        document.querySelector(".yotpo-selling-plans").before(subscriptionTitle);
    }
});

waitForElement2(".product__accordion accordion.quick-add-hidden", () => {
    document.querySelectorAll(".product__accordion accordion quick-add-hidden")[0].classList.remove("quick-add-hidden");
});

document.querySelector(".jdgm-rev-widg").style.marginTop = "-8rem";

waitForElement2(".candyrack-ppp-checkbox-layout__section--offers", () => {
    const pppOffers = document.querySelector(".candyrack-ppp-checkbox-layout__section--offers");
    pppOffers.querySelector("h3").textContent = "Add these shave essentials & SAVE 10%";
});
